import { useState, useEffect } from 'react';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { 
  Volume2, VolumeX, Bell, Settings, Play, Save
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const TIPOS_SOM = [
  { value: 'notification1', label: 'Notificação Clássica' },
  { value: 'notification2', label: 'Notificação Suave' },
  { value: 'notification3', label: 'Alerta Rápido' },
  { value: 'beep', label: 'Beep Simples' },
  { value: 'chime', label: 'Chime (Sino)' },
  { value: 'modern1', label: '🔔 Moderno - Pop' },
  { value: 'modern2', label: '🔔 Moderno - Ding' },
  { value: 'modern3', label: '🔔 Moderno - Bubble' },
  { value: 'urgent1', label: '🚨 Urgente - Alarme' },
  { value: 'urgent2', label: '🚨 Urgente - Sirene' },
  { value: 'whatsapp', label: '📱 Estilo WhatsApp' },
  { value: 'messenger', label: '💬 Estilo Messenger' },
  { value: 'telegram', label: '✈️ Estilo Telegram' }
];

// Sons em base64
const SONS = {
  notification1: 'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdH2Onp+ZjHdwaG15hp6vsLCliXVoZW95j6S2ubiqlH1uaW17kKjAy8i2nYRybW+Ck6/I1dPBpot4cHSIm7fO3NnHq5F+dHqRqcHW5OTUvqSOfXuOnrnR5O/s2sGnkYGElafE2+v28+PWvqOQiI6kt9Xp+Pv36tazoJOTpbzW6/3//+7byquclqW50uj7///16NOwop6osM7j+P//+uzXt6eioq+8z+P3///87NzAraajrrjK3fL+//7x4Ma0q6WqtL/P4fP9//zw4Mi4rqiqsrnH2Oz6/v3x4sy8s6yrs7nE1Of3/fz08NvHvLewtbnBzNvo9/v6+O/eyL+7t7W5v8jU4/H4+vjy5NLIw7+8u77Dytfk7/b4+Pfv5tXNx8PBwMHEx87Y4+zz9vf38OrkzcfDwsLDxsnP2OHr8fT19vDr5M7IxMPDxMbJztbf5+7z8/T27+vmzsrGxMTFx8rO09rh6O7x8vPz8O3n1M7KxsbGx8nM0NXb4Ofq7e/w8PHv6+TazsvIx8fIyczP09ja3+Pm6evs7e7u7Org2c7KycjIyMnLzdDS1dja3eHj5efp6uvs7Ovi2dHMysnJycnKy83P0tTW2dze4OLk5ufo6erg2NDMysnJycnJysvNz9HT1djb3d/h4+Xm5+jo6OHZz8zKycnJycnJysvNz9HT1djb3d/h4+Xm5+jo5+DXzsrJyMjIyMjJysvNz9HS1NfZ293f4ePl5ufo6eff1szJyMjIyMjIycnLzc/R0tTX2dve4OLk5ufo5+TdzsrIx8fHx8fHyMnLzc/R0tTX2dve4OPl5+jp59/UycfGxsbGxsbGx8jKzM7Q0tXY2t3f4uTm5+jp5tzNxcTDw8PDw8PExcfJy87Q09bZ3N/i5Ofp6ujh1MfDwsHBwcHBwcLDxcfJzM/R1Njb3+Ll6Onq6OHUxcLAwMDAwMDAwMHDxcjLztHU19rf4uXo6uro39LDv76+vr6+vr6/wMPGyczP0tbZ3eDj5unq6eff0MK+vb29vb29vb6/wcTHys3Q1Nfa3uHk5+rq6eXdzsC9vLy8vLy8vL2+wMPGys3R1Nfa3uHl6Orr6eXczcC9u7u7u7u7u7y9v8LFyMzP09fa3uHl5+rr6eXczcC9u7u7u7u7u7y9v8LFyMzP09fa3eHl5+rq6eXczcC9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+rq6eXczcC9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+rq6eXczb+9u7u7u7u7u7y9v8LFyMzP09fZ3eHk5+np6OTczb+9u7u7u7u7u7y9v8LFyMvP0tfZ3eHk5+np6OTbzL+9u7u7u7u7u7y9v8LFyMvP0tfZ3eDk5+np6OTbzL+9u7u7u7u7u7y9vsHFyMvO0tbZ3eDk5unp6OPbzL+9u7u7u7u7u7y9vsHFyMvO0tbZ3eDk5unp5+PazL+9u7u7',
  notification2: 'data:audio/wav;base64,UklGRl9EAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YTtEAACA/3//f/9//3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA/3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA/3//f/9//3//f/9//38AgACAAIAAgACAAIAAgP9//3//f/9//3//f/9/AIAAgACAAIAAgACAAID/f/9//3//f/9//3//fwCAAIAAgACAAIAAgACA',
  notification3: 'data:audio/wav;base64,UklGRqQFAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YYAFAACAgICAgICAgIB/f39/f39/gICAgICAgICAgH9/f39/f3+AgICAgICAgICAf39/f39/f4CAgICAgICAgIB/f39/f39/gICAgICAgICAgH9/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAgH9/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAf39/f39/f3+AgICAgICAgH9/f39/f39/gICAgICAgIB/f39/f39/f4CAgICAgICAf39/f39/f3+AgICAgICAgH9/f39/f39/',
  beep: 'data:audio/wav;base64,UklGRl9EAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YTtEAAD/f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//f/9//3//fwCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACA',
  chime: 'data:audio/wav;base64,UklGRpYEAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YXIEAACAf4B/gH+Af4B/gICAf4CAgICAgICAgYGBgYGBgYGCgoKCgoKCgoODg4ODg4ODhISEhISEhISFhYWFhYWFhoaGhoaGhoaHh4eHh4eHiIiIiIiIiImJiYmJiYmKioqKioqKi4uLi4uLi4yMjIyMjIyNjY2NjY2Njo6Ojo6OjpCQkJCQkJCRkZGRkZGRk5OTk5OTk5WVlZWVlZWXl5eXl5eXmZmZmZmZmZubm5ubm5udnZ2dnZ2dn5+fn5+fn6GhoaGhoaGjo6Ojo6Ojo6WlpaWlpaWnp6enp6enqampqampqaurq6urq6utra2tra2tr6+vr6+vr7GxsbGxsbGzs7Ozs7Ozs7W1tbW1tbW3t7e3t7e3ubm5ubm5ubu7u7u7u7u9vb29vb29v7+/v7+/v8HBwcHBwcHDw8PDw8PDxcXFxcXFxcfHx8fHx8fJycnJycnJy8vLy8vLy83Nzc3Nzc3Pz8/Pz8/P0dHR0dHR0dPT09PT09PV1dXV1dXV19fX19fX19nZ2dnZ2dna2tra2tra3Nzc3Nzc3N7e3t7e3t7g4ODg4ODg4uLi4uLi4uTk5OTk5OTm5ubm5ubm6Ojo6Ojo6Orq6urq6urr6+vr6+vr7e3t7e3t7e/v7+/v7+/x8fHx8fHx8/Pz8/Pz8/X19fX19fX39/f39/f3+fn5+fn5+fv7+/v7+/v9/f39/f39//////////////////////////////////8='
};

// Função para gerar sons usando Web Audio API (mais modernos e altos)
function gerarSomWebAudio(tipo, volume = 1) {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const gainNode = audioContext.createGain();
    gainNode.connect(audioContext.destination);
    gainNode.gain.value = volume * 1.5; // Volume mais alto
    
    const now = audioContext.currentTime;
    
    switch(tipo) {
      case 'modern1': // Pop moderno
        [880, 1100, 1320].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.1);
          osc.stop(now + i * 0.1 + 0.15);
        });
        break;
        
      case 'modern2': // Ding duplo
        [1200, 1600].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.15);
          osc.stop(now + i * 0.15 + 0.2);
        });
        break;
        
      case 'modern3': // Bubble
        const osc1 = audioContext.createOscillator();
        osc1.type = 'sine';
        osc1.frequency.setValueAtTime(400, now);
        osc1.frequency.exponentialRampToValueAtTime(1200, now + 0.2);
        osc1.connect(gainNode);
        osc1.start(now);
        osc1.stop(now + 0.25);
        break;
        
      case 'urgent1': // Alarme urgente
        [800, 1000, 800, 1000].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'square';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.12);
          osc.stop(now + i * 0.12 + 0.1);
        });
        break;
        
      case 'urgent2': // Sirene curta
        const oscSirene = audioContext.createOscillator();
        oscSirene.type = 'sawtooth';
        oscSirene.frequency.setValueAtTime(600, now);
        oscSirene.frequency.linearRampToValueAtTime(1200, now + 0.3);
        oscSirene.frequency.linearRampToValueAtTime(600, now + 0.6);
        oscSirene.connect(gainNode);
        oscSirene.start(now);
        oscSirene.stop(now + 0.6);
        break;
        
      case 'whatsapp': // Estilo WhatsApp
        [1046.5, 1318.5].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'sine';
          osc.frequency.value = freq;
          const env = audioContext.createGain();
          env.gain.setValueAtTime(0, now + i * 0.08);
          env.gain.linearRampToValueAtTime(volume * 1.5, now + i * 0.08 + 0.02);
          env.gain.exponentialRampToValueAtTime(0.01, now + i * 0.08 + 0.15);
          osc.connect(env);
          env.connect(audioContext.destination);
          osc.start(now + i * 0.08);
          osc.stop(now + i * 0.08 + 0.15);
        });
        break;
        
      case 'messenger': // Estilo Messenger
        const oscMsg = audioContext.createOscillator();
        oscMsg.type = 'sine';
        oscMsg.frequency.setValueAtTime(987.77, now);
        oscMsg.frequency.setValueAtTime(1318.5, now + 0.1);
        oscMsg.connect(gainNode);
        oscMsg.start(now);
        oscMsg.stop(now + 0.2);
        break;
        
      case 'telegram': // Estilo Telegram
        [523.25, 659.25, 783.99].forEach((freq, i) => {
          const osc = audioContext.createOscillator();
          osc.type = 'triangle';
          osc.frequency.value = freq;
          osc.connect(gainNode);
          osc.start(now + i * 0.07);
          osc.stop(now + i * 0.07 + 0.12);
        });
        break;
        
      default:
        return false;
    }
    return true;
  } catch(e) {
    console.log('Erro Web Audio:', e);
    return false;
  }
}

export default function ConfiguracaoSomPage() {
  const [config, setConfig] = useState({
    ativo: true,
    som_tipo: 'notification1',
    volume: 0.7,
    tocar_em_todas_paginas: true,
    intervalo_verificacao: 5
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = () => {
    setLoading(true);
    axios.get(API + '/config/som', { headers: getAuthHeader() })
      .then(res => {
        if (res.data) {
          setConfig(res.data);
        }
      })
      .catch(() => toast.error('Erro ao carregar configurações'))
      .finally(() => setLoading(false));
  };

  const salvarConfig = () => {
    setSaving(true);
    axios.put(API + '/config/som', null, {
      headers: getAuthHeader(),
      params: {
        ativo: config.ativo,
        som_tipo: config.som_tipo,
        volume: config.volume,
        tocar_em_todas_paginas: config.tocar_em_todas_paginas,
        intervalo_verificacao: config.intervalo_verificacao
      }
    })
      .then(() => {
        toast.success('Configurações salvas com sucesso!');
        // Disparar evento para atualizar o componente global de notificação
        window.dispatchEvent(new Event('som-config-updated'));
      })
      .catch(() => toast.error('Erro ao salvar configurações'))
      .finally(() => setSaving(false));
  };

  const testarSom = () => {
    // Primeiro tenta usar Web Audio para sons modernos
    if (['modern1', 'modern2', 'modern3', 'urgent1', 'urgent2', 'whatsapp', 'messenger', 'telegram'].includes(config.som_tipo)) {
      if (gerarSomWebAudio(config.som_tipo, config.volume)) {
        return;
      }
    }
    
    // Fallback para sons em base64
    try {
      const somSrc = SONS[config.som_tipo] || SONS.notification1;
      const audio = new Audio(somSrc);
      audio.volume = config.volume;
      audio.play();
    } catch (e) {
      toast.error('Erro ao tocar som de teste');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="config-som-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-800 flex items-center gap-2">
            <Volume2 className="w-8 h-8 text-blue-600" />
            Configuração de Som
          </h1>
          <p className="text-slate-500">Configure as notificações sonoras do sistema</p>
        </div>
        <Button onClick={salvarConfig} disabled={saving} className="bg-blue-600 hover:bg-blue-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Salvando...' : 'Salvar Configurações'}
        </Button>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {/* Status Geral */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Bell className="w-5 h-5 text-blue-600" />
              Status da Notificação
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
              <div className="flex items-center gap-3">
                {config.ativo ? (
                  <Volume2 className="w-8 h-8 text-green-600" />
                ) : (
                  <VolumeX className="w-8 h-8 text-red-500" />
                )}
                <div>
                  <p className="font-medium text-slate-800">
                    Som de Notificação
                  </p>
                  <p className="text-sm text-slate-500">
                    {config.ativo ? 'Ativado' : 'Desativado'}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setConfig({ ...config, ativo: !config.ativo })}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                  config.ativo ? 'bg-green-600' : 'bg-slate-300'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    config.ativo ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
              <div>
                <p className="font-medium text-slate-800">Tocar em todas as páginas</p>
                <p className="text-sm text-slate-500">
                  Som toca mesmo fora da página de atendimento
                </p>
              </div>
              <button
                onClick={() => setConfig({ ...config, tocar_em_todas_paginas: !config.tocar_em_todas_paginas })}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                  config.tocar_em_todas_paginas ? 'bg-green-600' : 'bg-slate-300'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    config.tocar_em_todas_paginas ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </CardContent>
        </Card>

        {/* Tipo de Som */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Settings className="w-5 h-5 text-blue-600" />
              Tipo de Som
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label className="text-sm font-medium text-slate-700">Selecione o som</Label>
              <div className="flex gap-2 mt-2">
                <select
                  value={config.som_tipo}
                  onChange={(e) => setConfig({ ...config, som_tipo: e.target.value })}
                  className="flex-1 h-10 rounded-md border border-slate-300 bg-white px-3 text-sm"
                >
                  {TIPOS_SOM.map(som => (
                    <option key={som.value} value={som.value}>{som.label}</option>
                  ))}
                </select>
                <Button variant="outline" onClick={testarSom}>
                  <Play className="w-4 h-4 mr-1" />
                  Testar
                </Button>
              </div>
            </div>

            <div>
              <Label className="text-sm font-medium text-slate-700">
                Volume: {Math.round(config.volume * 100)}%
              </Label>
              <input
                type="range"
                min="0"
                max="100"
                value={config.volume * 100}
                onChange={(e) => setConfig({ ...config, volume: parseInt(e.target.value) / 100 })}
                className="w-full h-2 mt-2 bg-slate-200 rounded-lg appearance-none cursor-pointer"
              />
              <div className="flex justify-between text-xs text-slate-400 mt-1">
                <span>0%</span>
                <span>50%</span>
                <span>100%</span>
              </div>
            </div>

            <div>
              <Label className="text-sm font-medium text-slate-700">
                Intervalo de verificação: {config.intervalo_verificacao} segundos
              </Label>
              <input
                type="range"
                min="3"
                max="30"
                value={config.intervalo_verificacao}
                onChange={(e) => setConfig({ ...config, intervalo_verificacao: parseInt(e.target.value) })}
                className="w-full h-2 mt-2 bg-slate-200 rounded-lg appearance-none cursor-pointer"
              />
              <div className="flex justify-between text-xs text-slate-400 mt-1">
                <span>3s (mais rápido)</span>
                <span>30s (economia)</span>
              </div>
              <p className="text-xs text-slate-500 mt-2">
                Define com que frequência o sistema verifica novas mensagens
              </p>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Preview */}
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="py-4">
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center ${config.ativo ? 'bg-green-100' : 'bg-red-100'}`}>
              {config.ativo ? (
                <Volume2 className="w-6 h-6 text-green-600" />
              ) : (
                <VolumeX className="w-6 h-6 text-red-500" />
              )}
            </div>
            <div>
              <p className="font-medium text-slate-800">Resumo da Configuração</p>
              <p className="text-sm text-slate-600">
                Som {config.ativo ? 'ativado' : 'desativado'} | 
                Tipo: {TIPOS_SOM.find(s => s.value === config.som_tipo)?.label} | 
                Volume: {Math.round(config.volume * 100)}% | 
                Verificação: {config.intervalo_verificacao}s
                {config.tocar_em_todas_paginas && ' | Toca em todas as páginas'}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
